export const likeStatusReducer = (state, {type, payload}) => {
    console.log(state);
    switch (type) {
        case "clickLike":
            console.log("clickLike");
            return !state;
        case "initLike":
            console.log("initLike");
            return payload;
        default:
            return state;
    }
}

export const likeCountReducer = (state, {type, payload}) => {
    console.log(state);
    switch (type) {
        case "addLikeCount":
            console.log("addLikeCount");
            return state + 1;
        case "removeLikeCount":
            console.log("removeLikeCount");
            return state - 1;
        case "initCount":
            console.log("initCount");
            return payload;
        default:
            return state;
    }
}
